"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AsyncDataAccessor_1 = require("../../DOM/HTMLElement/AsyncDataAccessor");
class BrowserStorage {
    constructor(engine) {
        this.engine = engine;
        this.dataAccessor = new AsyncDataAccessor_1.default((storageEngine, key) => storageEngine.getValue(key), (storageEngine, key, value) => storageEngine.setValue(key, value));
    }
    async clear() {
        return this.engine.clear();
    }
    async keys() {
        return this.engine.keys();
    }
    async remove(key) {
        return this.engine.remove(key);
    }
    async getInt(key, defaultValue) {
        return this.dataAccessor.getInt(this.engine, key, defaultValue);
    }
    async getIntOrNull(key, defaultValue) {
        return this.dataAccessor.getIntOrNull(this.engine, key, defaultValue);
    }
    async getFloat(key, defaultValue) {
        return this.dataAccessor.getFloat(this.engine, key, defaultValue);
    }
    async getFloatOrNull(key, defaultValue) {
        return this.dataAccessor.getFloatOrNull(this.engine, key, defaultValue);
    }
    async getString(key, defaultValue) {
        return this.dataAccessor.getString(this.engine, key, defaultValue);
    }
    async getStringOrNull(key, defaultValue) {
        return this.dataAccessor.getStringOrNull(this.engine, key, defaultValue);
    }
    async getJson(key, defaultValue) {
        return this.dataAccessor.getJson(this.engine, key, defaultValue);
    }
    async getJsonOrNull(key, defaultValue) {
        return this.dataAccessor.getJsonOrNull(this.engine, key, defaultValue);
    }
    async setInt(key, value) {
        return this.dataAccessor.setInt(this.engine, key, value);
    }
    async setFloat(key, value) {
        return this.dataAccessor.setFloat(this.engine, key, value);
    }
    async setString(key, value) {
        return this.dataAccessor.setString(this.engine, key, value);
    }
    async setJson(key, value, stringify = true) {
        return this.dataAccessor.setJson(this.engine, key, value, stringify);
    }
}
exports.default = BrowserStorage;
//# sourceMappingURL=BrowserStorage.js.map